import React, { useCallback } from 'react';
import { Config } from '../../config';
import { Modal, ModalType } from '@hugendubel/react-basic';
import { ConfirmPickup } from '../components/modals/ConfirmPickup';
import { ReducedProduct } from '../../ws/result/ReducedProduct';

export const _UsePickupButtonHandler = {
    openPickupConfirm: (article: ReducedProduct) =>
        Modal.open(
            <ConfirmPickup article={article} close={Modal.close} />,
            'modal.pickup.confirmation.title',
            ModalType.NOTIFY
        ),
};

export const usePickupButtonHandler = (article: ReducedProduct): undefined | (() => void) => {
    const { deliveryInformation, availability } = article;
    const BRANCH_ONLY_BONUS_ARTICLE = 210;
    const isBranchOnlyArticle = availability?.number === BRANCH_ONLY_BONUS_ARTICLE;

    const pickupConfirm = useCallback(() => _UsePickupButtonHandler.openPickupConfirm(article), [article]);

    return Config.get().isPhysicalBookstore &&
        (deliveryInformation?.pickupPossible || isBranchOnlyArticle) &&
        !deliveryInformation?.download
        ? pickupConfirm
        : undefined;
};
